import { useMemo } from 'react';
import { PayerDirectorySearch } from '@features/payer-search';

interface LegacyPayer {
  id: string;
  name: string;
  eligibility: string;
}

interface PayerSearchProps {
  disabled?: boolean;
  onPayerSelect: (payer: LegacyPayer | null) => void;
  value: LegacyPayer | null;
}

/** Backward-compatible patient insurance wrapper around the shared STEDI search. */
export default function PayerSearch({ disabled = false, onPayerSelect, value }: PayerSearchProps) {
  const searchValue = useMemo(
    () => (value ? { displayName: value.name, payerId: value.id, stediId: value.id } : null),
    [value],
  );

  return (
    <PayerDirectorySearch
      disabled={disabled}
      helperText="Search by payer name or ID"
      label="Search Payers"
      onSelect={payer =>
        onPayerSelect(
          payer ? { id: payer.stedi_id, name: payer.display_name, eligibility: '' } : null,
        )
      }
      placeholder="Search by name or payer ID"
      value={searchValue}
    />
  );
}
